/* eslint-disable */
'use strict';

// supporting browsers that do not have Intl.PluralRules (e.g IE11 & Safari 12-)
import('@formatjs/intl-pluralrules');

// supporting browsers that do not have Intl.RelativeTimeFormat (e.g IE11, Edge, Safari 13-)
import('@formatjs/intl-relativetimeformat');

// fetch() polyfill for making API calls.
import('whatwg-fetch');

// Okta IE11 compatibility
import('@okta/okta-auth-js/polyfill');

if (!String.prototype.padStart) {
  String.prototype.padStart = function padStart(targetLength, padString) {
    targetLength = targetLength >> 0; //truncate if number, or convert non-number to 0;
    padString = String(typeof padString !== 'undefined' ? padString : ' ');
    if (this.length >= targetLength) {
      return String(this);
    } else {
      targetLength = targetLength - this.length;
      if (targetLength > padString.length) {
        // append to original to ensure we are longer than needed
        padString += padString.repeat(targetLength / padString.length);
      }
      return padString.slice(0, targetLength) + String(this);
    }
  };
}
